import { render, staticRenderFns } from "./GalleriesForm.vue?vue&type=template&id=6e958678&scoped=true"
import script from "./GalleriesForm.vue?vue&type=script&lang=js"
export * from "./GalleriesForm.vue?vue&type=script&lang=js"
import style0 from "./GalleriesForm.vue?vue&type=style&index=0&id=6e958678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e958678",
  null
  
)

export default component.exports